// Swym Login Component Customizer
// This script customizes the Swym login heading text globally

(function () {
  "use strict";

  // Function to change the login heading text without visible transition
  function changeLoginHeading() {
    const loginHeadings = document.querySelectorAll(
      ".swym-storefront-layout-login-heading"
    );
    let changed = false;

    loginHeadings.forEach(function (heading) {
      if (heading.textContent !== "Don't Lose Your Wishlist!") {
        // Hide the element completely to prevent visible transition
        const originalDisplay = heading.style.display;
        const originalVisibility = heading.style.visibility;
        const originalOpacity = heading.style.opacity;

        // Make it completely invisible
        heading.style.display = "none";
        heading.style.visibility = "hidden";
        heading.style.opacity = "0";

        // Change the text
        heading.textContent = "Don't Lose Your Wishlist!";

        // Show it again after a longer delay to ensure text change is complete
        setTimeout(function () {
          heading.style.display = originalDisplay || "block";
          heading.style.visibility = originalVisibility || "visible";
          heading.style.opacity = originalOpacity || "1";
        }, 200);

        changed = true;
      }
    });

    return changed;
  }

  // Function to observe for Swym login components and change the heading
  function observeSwymLoginComponents() {
    const observer = new MutationObserver(function (mutations) {
      let shouldCheck = false;

      mutations.forEach(function (mutation) {
        if (mutation.type === "childList") {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) {
              // Element node
              // Check if the node itself is a login heading
              if (
                node.classList &&
                node.classList.contains("swym-storefront-layout-login-heading")
              ) {
                shouldCheck = true;
              }
              // Check if the node contains login headings
              if (
                node.querySelector &&
                node.querySelector(".swym-storefront-layout-login-heading")
              ) {
                shouldCheck = true;
              }
            }
          });
        }
      });

      if (shouldCheck) {
        changeLoginHeading();
      }
    });

    // Start observing the document body for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return observer;
  }

  // Initialize when DOM is ready
  function init() {
    // Start observing for Swym login components
    observeSwymLoginComponents();

    // Try to change existing elements immediately
    changeLoginHeading();
  }

  // Run initialization
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Listen for Swym events
  document.addEventListener("swym:collections-loaded", changeLoginHeading);

  // Make function globally available for manual calls
  window.changeSwymLoginHeading = changeLoginHeading;
})();
